import api from './api';

// =====================
// Release Test Cases
// =====================

export const addTestCasesToRelease = (releaseId, testCaseIds) => {
  return api.post(`/releases/${releaseId}/test-cases`, { test_case_ids: testCaseIds });
};

export const getReleaseTestCases = (releaseId, filters = {}) => {
  const params = new URLSearchParams(filters);
  return api.get(`/releases/${releaseId}/test-cases?${params.toString()}`);
};

export const updateReleaseTestCase = (releaseId, testCaseId, updateData) => {
  return api.put(`/releases/${releaseId}/test-cases/${testCaseId}`, updateData);
};

export const removeTestCaseFromRelease = (releaseId, testCaseId) => {
  return api.delete(`/releases/${releaseId}/test-cases/${testCaseId}`);
};

// =====================
// Dashboard
// =====================

export const getReleaseDashboard = (releaseId) => {
  return api.get(`/releases/${releaseId}/dashboard`);
};

// =====================
// Tree View
// =====================

export const getReleaseTreeView = (releaseId) => {
  return api.get(`/releases/${releaseId}/tree`);
};

// =====================
// Approvals
// =====================

export const createApproval = (releaseId, approvalData) => {
  return api.post(`/releases/${releaseId}/approvals`, approvalData);
};

export const getReleaseApprovals = (releaseId) => {
  return api.get(`/releases/${releaseId}/approvals`);
};

export const updateApproval = (releaseId, approvalId, updateData) => {
  return api.put(`/releases/${releaseId}/approvals/${approvalId}`, updateData);
};

// =====================
// History
// =====================

export const getReleaseHistory = (releaseId, limit = 50) => {
  return api.get(`/releases/${releaseId}/history?limit=${limit}`);
};

// =====================
// Scopes
// =====================

export const createScope = (releaseId, scopeData) => {
  return api.post(`/releases/${releaseId}/scopes`, scopeData);
};

export const getReleaseScopes = (releaseId) => {
  return api.get(`/releases/${releaseId}/scopes`);
};

export const getScope = (releaseId, scopeId) => {
  return api.get(`/releases/${releaseId}/scopes/${scopeId}`);
};

export const updateScope = (releaseId, scopeId, updateData) => {
  return api.put(`/releases/${releaseId}/scopes/${scopeId}`, updateData);
};

export const deleteScope = (releaseId, scopeId) => {
  return api.delete(`/releases/${releaseId}/scopes/${scopeId}`);
};

export const assignIssuesToScope = (releaseId, scopeId, issueIds) => {
  return api.post(`/releases/${releaseId}/scopes/${scopeId}/assign-issues`, { issue_ids: issueIds });
};

export const unassignIssuesFromScope = (releaseId, scopeId, issueIds) => {
  return api.post(`/releases/${releaseId}/scopes/${scopeId}/unassign-issues`, { issue_ids: issueIds });
};

export const getScopeSwimlane = (releaseId) => {
  return api.get(`/releases/${releaseId}/scope-swimlane`);
};

// =====================
// Go / No-Go
// =====================

export const getGoNoGo = (releaseId) => {
  return api.get(`/releases/${releaseId}/go-nogo`);
};

// =====================
// Defect Density
// =====================

export const getDefectDensity = (releaseId) => {
  return api.get(`/releases/${releaseId}/defect-density`);
};

// =====================
// Enhanced Dashboard
// =====================

export const getEnhancedDashboard = (releaseId) => {
  return api.get(`/releases/${releaseId}/enhanced-dashboard`);
};
